import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faCalendarWeek,
  faCalendar,
  faCalendarTimes,
  faPlus,
  faCaretDown,
  faExclamationCircle,
  faCheckCircle,
  faClock,
  faTrash,
  faSave,
  faSearch,
  faHandsHelping,
  faShoePrints,
  faBookmark,
  faCaretLeft,
  faTasks,
  faCaretRight
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faCalendarWeek,
  faCalendar,
  faCalendarTimes,
  faPlus,
  faCaretDown,
  faExclamationCircle,
  faCheckCircle,
  faClock,
  faTrash,
  faSave,
  faSearch,
  faHandsHelping,
  faShoePrints,
  faBookmark,
  faCaretLeft,
  faTasks,
  faCaretRight
)

export default FontAwesomeIcon
